import "UI/Plugin/Base";
NS("UI.Plugin");

UI.Plugin.Autocomplete = Class(UI.Plugin.Base, {
    template: "UI/Plugin/Autocomplete/Autocomplete",
    itemTemplate: "UI/Plugin/Autocomplete/AutocompleteItem",

    /*
    options: {
    	source: {function},
    	columns: {Array},
    	column: {String},
    	onSelect: {function}
    }
     */

    source: null,
    columns: [],
    column: null,
    strict: false,
    strictCallback: null,

    input: null,
    div: null,
    list: null,
    actualValue: "",
    anchor: "leftBottom",

    items: [],
    current: 0,

    clearTimeout: null,

    initialize: function(element, options) {
        var self = this;

        options = Util.object(options);

        this.Parent(element, options);

        if (!this.columns) {
            this.columns = [this.column];
        }

        this.input = this.element.$element.is('input') ? this.element.$element : this.element.$element.find('input[type=text]');

        this.div = UI.Template.$render(this.template).appendTo("body");
        this.list = this.div.find("[name=list]");

        this.read();

        this.keyDownHandler = function(args) {
            self.processKey(args.keyCode);
        };

        this.windowClickHandler = function() {
            self.hide();
        };

        this.blurHandler = function() {
            var val = self.input.val();

            if (val != self.actualValue) {
                self.input.val(self.actualValue);

                if (Util.isFunction(self.strictCallback)) {
                    self.strictCallback({
                        value: val,
                        actual: self.actualValue
                    }, self.input);
                }
            }

            self.input.trigger("change");
        };

        this.input.on("keydown", this.keyDownHandler);
        this.element.liveChange().on("livechange", this.onLiveChange, this);

        if (this.strict) {
            this.input.on("blur", this.blurHandler);
        }

        this.div.hide();
    },

    destroy: function() {
        this.hide();

        if (this.clearTimeout) {
            clearTimeout(this.clearTimeout);
            this.clearTimeout = null;
        }

        this.element.off("livechange");
        this.input.off("keydown", this.keyDownHandler);

        this.unregisterWindowEvent();

        this.div.remove();

        this.source = null;
        this.strictCallback = null;
        this.input = null;
        this.div = null;
        this.list = null;
        this.items = [];

        this.ParentCall();
    },

    show: function() {
        this.div.show();

        this.align();

        this.registerWindowEvent();
    },

    hide: function() {
        this.div.hide();

        if (this.changeTimeout) {
            clearTimeout(this.changeTimeout);
            this.changeTimeout = null;
        }

        this.unregisterWindowEvent();
    },

    visible: function() {
        return this.div.is(":visible");
    },

    align: function() {
        var offset = this.input.offset();
        var height = this.input.outerHeight();
        var width = this.input.outerWidth();

        switch (this.anchor) {
            case "rightBottom":
                this.div.css("top", offset.top + height);
                this.div.css("right", $("body").width() - offset.left - width);
                break;
            default:
                this.div.css("top", offset.top + height);
                this.div.css("left", offset.left);
                break;
        }
    },

    read: function() {
        this.actualValue = this.input.val();
        this.savedValue = this.input.val();
    },

    load: function() {
        var self = this;
        var pattern = this.element.val();

        return this.source({
            pattern: pattern
        }, function(data) {
            self.items = data;

            self.update();

            return self.items;
        });
    },

    update: function() {
        var self = this;

        this.list.empty();

        for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            var itemDiv = UI.Template.$render(this.itemTemplate, {
                plugin: this,
                item: item,
                index: i
            }).appendTo(this.list);

            itemDiv.attr("index", i);

            (function(i) {
                itemDiv.on("click", function() {
                    self.onItemSelect(i);
                });
            })(i);
        }

        this.current = 0;
        this.highlight();
    },
    makeCell: function (item, cell) {
        if (item[cell]) {
            return item[cell]
        } else {
            return cell.replace(/{[^{}]+}/g, function(key){
                return item[key.replace(/[{}]+/g, "")] || "";
            });
        }
    },
    highlight: function() {
        $(".autocomplete__selected", this.div).removeClass("autocomplete__selected");
        $("[index=" + this.current + "]", this.div).addClass("autocomplete__selected");

        this.scrollToSelected();
    },

    scrollToSelected: function() {
        var element = $("[index=" + this.current + "]", this.div);

        if (element.length) {
            var spaceHeight = this.div.outerHeight();
            var height = element.outerHeight();
            var position = element.position();

            if (position.top + height > spaceHeight) {
                element[0].scrollIntoView(false);
            } else if (position.top < 0) {
                element[0].scrollIntoView();
            }
        }
    },

    clearValue: function() {

        this.savedValue = "";
        this.actualValue = "";
        this.input.val("");

        this.emit("select", {
            item: null
        });

        if (Util.isFunction(this.onSelect)) {
            this.onSelect(null);
        }
    },

    processKey: function(code) {
        var self = this;
        switch (code) {
            case KeyCode.Tab:
                if (this.visible()) {
                    this.onItemSelect(this.current);
                }
                this.hide();
                break;
            case KeyCode.Escape:
                if (!this.clearTimeout) {
                    this.clearTimeout = setTimeout(function() {
                        self.clearTimeout = null;
                    }, 300);
                } else {
                    clearTimeout(this.clearTimeout);
                    this.clearTimeout = null;

                    this.savedValue = "";
                    this.actualValue = "";
                    this.input.val("");

                    this.emit("select", {
                        item: null
                    });

                    if (Util.isFunction(this.onSelect)) {
                        this.onSelect(null);
                    }
                }
                this.hide();
                break;
            case KeyCode.Down:
                if (!this.visible()) {
                    this.load();
                    this.show();
                } else {
                    if (this.current < this.items.length - 1) {
                        this.current++;
                        this.highlight();
                    }
                }
                break;
            case KeyCode.Up:
                if (!this.visible()) {
                    this.load();
                    this.show();
                } else {
                    if (this.current > 0) {
                        this.current--;
                        this.highlight();
                    }
                }
                break;
            case KeyCode.Enter:
                if (this.visible()) {
                    this.onItemSelect(this.current);
                }
                break;
        }
    },

    registerWindowEvent: function() {
        $(window).on("click", this.windowClickHandler);
    },

    unregisterWindowEvent: function() {
        $(window).off("click", this.windowClickHandler);
    },

    onLiveChange: function() {
        var val = this.input.val();

        if (val != this.savedValue) {
            this.savedValue = val;

            this.load();

            if (!this.visible()) {
                this.show();
            }

            if (this.savedValue === "") {
                this.emit("empty");
            }
        }
    },

    onItemSelect: function(index) {
        var item = index === undefined ? null : this.items[index];

        if (item) {
            this.actualValue = item ? item[this.column] : "";
            this.input.val(this.actualValue);
            this.savedValue = this.actualValue;

            this.input.data("item", JSON.stringify(item));

            this.input.trigger("change");

            this.emit("select", {
                item: item
            });

            if (Util.isFunction(this.onSelect)) {
                this.onSelect(item);
            }
        }

        this.hide();
    }
});
